export default __webpack_public_path__ + "static/media/GPCard.3a651fcb.png";